export const getIcons = state => state.icon?.present;
export const undoable = state => state.icon?.past.length > 0;
export const redoable = state => state.icon?.future.length > 0;

export const getIconById = state => id => {
  return state.icon.present[id];
};
